import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhitoUserDTO } from '../../../../services/phito-object';
import { BackendApiService } from '../../../../services/backend-api.service';
import { NotificationService } from '../../../../services/notification.service';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'phito-user-change-dialog',
    templateUrl: './user-change-dialog.component.html',
    styleUrls: ['./user-change-dialog.component.css'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatFormField,
        MatLabel,
        MatSelect,
        FormsModule,
        ReactiveFormsModule,
        MatOption,
        MatDialogActions,
        MatButton,
    ],
})
export class UserChangeDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<UserChangeDialogComponent>>(MatDialogRef);
    private api = inject(BackendApiService);
    private notificationService = inject(NotificationService);

    userCtrl = new FormControl();
    users: PhitoUserDTO[] = [];

    ngOnInit(): void {
        this.loadUsers();
    }

    loadUsers() {
        this.api.getGeneric('userdto/query/usersofmyusergroups').subscribe(
            (response) => {
                this.users = response.data;
            },
            (error) => {
                this.notificationService.errorMessageGet('Benutzer konnten nicht geladen werden!', error, null);
            },
        );
    }

    cancel() {
        this.dialogRef.close(null);
    }

    changeUser() {
        if (!this.userCtrl.value) {
            this.notificationService.alertMessage('Keinen Benutzer ausgewählt!');
        } else {
            let u: PhitoUserDTO = this.userCtrl.value;
            this.dialogRef.close(u);
        }
    }

    resetUser() {
        let u = new PhitoUserDTO();
        u.userHexId = null;
        u.firstName = null;
        u.lastName = null;
        this.dialogRef.close(u);
    }

    selectionChanged(event) {
        this.changeUser();
    }
}
